import React from 'react';
import { ISelectOption } from '../../../domain/saved-filters/interface';
import { BaseFilterCheckboxSelect } from '../base/BaseFilterCheckboxSelect';

interface IAlertTrackUserSelectProps {
    value: string[] | undefined;
    onChange: (value: string[]) => void;
    options: ISelectOption<string>[];
    label?: string;
    disabled?: boolean;
    isLoading?: boolean;
}

export const AlertTrackUserSelect: React.FC<IAlertTrackUserSelectProps> = ({ disabled = false, value = [], onChange, label, options, isLoading }) => {
    return (
        <BaseFilterCheckboxSelect
            resizable
            searchable
            multiple
            showSelectAllOption={false}
            selectedCountInLabel
            showClear
            options={options}
            value={value}
            onChange={onChange}
            label={label}
            disabled={disabled}
            loading={isLoading}
            height={300}
        />
    );
};
